// extracted by mini-css-extract-plugin
export default {"title":"RdpHeader-module__title__Fn05r"};